import { createContext, type ReactNode, useContext } from "react";

const AgentIntentModelContext = createContext(false);

export const AgentIntentModelProvider = ({
  children,
  hasIntentModel,
}: {
  children: ReactNode;
  hasIntentModel: boolean;
}) => (
  <AgentIntentModelContext.Provider value={hasIntentModel}>
    {children}
  </AgentIntentModelContext.Provider>
);

export const useHasAgentIntentModel = () => useContext(AgentIntentModelContext);
